import ProductInfoCard from './ProductInfoCard'

export default ProductInfoCard
